// Image / content split (1/3 : 2/3, matching book-meeting's ratio). Normal document flow (used
// with the admin layout's `fullWidthMain` opt-in) so body is the only scroll owner, same as every
// other page — no fixed/sticky, no competing scrollbar. Image hides below `lg`, matching AuthSplitLayout.
const SplitContentLayout = ({
  imageSrc,
  imageAlt,
  children,
}: {
  imageSrc: string;
  imageAlt: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="grid min-h-[calc(100vh-4rem)] lg:grid-cols-[1fr_2fr]">
      <div className="relative hidden bg-neutral-900 lg:block">
        <img src={imageSrc} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <div className="flex flex-col items-center bg-neutral-50 px-6 py-6">
        <div className="w-full max-w-lg lg:my-auto">{children}</div>
      </div>
    </div>
  );
};

export default SplitContentLayout;
